module.exports = __webpack_public_path__ + "6318912cdd6788793bfc2afbdcbddc57.woff";